import React from 'react';
import { useSelector } from 'react-redux';
import { DoctorListItem } from './DoctorListItem/DoctorListItem';
import { getSelectedDate, getTimeslots } from '../../store/selectors';

export const DoctorList = () => {
    const date = useSelector(getSelectedDate);
    const timeslots = useSelector(getTimeslots);
    return (
        <>
            <ul>
                {
                    timeslots?.map(item => <DoctorListItem key={item?.doctorId} date={date} doctorData={item}/>)
                }
            </ul>
        </>
    );
};
